const QURAN_PAGES_COUNT = 604;
export default class QuranPagesService {
  static allQuranPages: string[];

  static getAllQuranPages() {
    if (!!this.allQuranPages && this.allQuranPages.length > 0) {
      return this.allQuranPages;
    }
    this.generateAllQuranPages();
    return this.allQuranPages;
  }

  static generateAllQuranPages() {
    this.allQuranPages = [];
    for (let i = 0; i < QURAN_PAGES_COUNT; i++) {
      this.allQuranPages.push(this.generatePageLink(i));
    }
  }

  static generateQuranPagesLinks(
    numberOfPages: number = 20,
    startPage: number = 1
  ) {
    if (startPage + numberOfPages > QURAN_PAGES_COUNT - 1) {
      throw new Error("Pages number is out of bounds");
    }
    const quranPages = [];
    for (let i = startPage; i < numberOfPages; i++) {
      quranPages.push(this.generatePageLink(i));
    }
    return quranPages;
  }

  static generatePageLink(pageNumber: number) {
    return `${process.env.REACT_APP_BASE_QURAN_PAGE_URL}/${pageNumber}${process.env.REACT_APP_BASE_QURAN_PAGE_EXTENSION}`;
  }
}
